var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { AwesomeEvent, ComponentAPI } from '@philips-internal/oswald-ui-core';
import { CollapseEvent, CollapseEventListener } from '@philips-internal/oswald-ui-core/lib/component/types/index.js';
class ExpanderAPI extends ComponentAPI {
    constructor() {
        super(...arguments);
        /** @event */
        this.onCollapse = new CollapseEventListener();
    }
    /**
     * Returns if the expander arrow is visible or not
     */
    isArrowVisible() {
        return this.state.arrowVisible;
    }
    /**
     * Updates the visibility state of the expander arrow.
     *
     * @param arrowVisible - The updated visibility state.
     */
    setArrowVisible(arrowVisible) {
        this.setState({ arrowVisible });
    }
    /**
     * Returns if the expandable content is expanded or not
     */
    isCollapsed() {
        // P.S. It's called collapsed just to comply with collapsible interface
        return !this.state.expanded;
    }
    /**
     * Updates the expanded state of the component.
     *
     * @param collapsed - The updated expanded state.
     */
    setCollapsed(collapsed) {
        // P.S. It's called collapsed just to comply with collapsible interface
        this.onCollapse.fire(new CollapseEvent({ collapsed }));
        this.setState({ expanded: !collapsed });
    }
    /**
     * Returns if the content of expandable slot will be initially expanded or collapsed
     */
    isInitiallyExpanded() {
        return this.state.initiallyExpanded;
    }
    /**
     * Sets if the content of expandable slot will be initially expanded or collapsed
     * @param initiallyExpanded if the content will be expanded or collapsed
     */
    setInitiallyExpanded(initiallyExpanded) {
        this.setState({ initiallyExpanded });
    }
}
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], ExpanderAPI.prototype, "onCollapse", void 0);
export { ExpanderAPI, };
//# sourceMappingURL=expander-api.js.map